<template>
  <div id="app" @click="makeReady">
    <app-header/>
    <main class="main pt0 px2 sm-px3 md-px2">
      <router-view/>
    </main>
  </div>
</template>

<script>
  import AppHeader from '@/components/partials/AppHeader'

  export default {
    name: 'app',
    methods: {
      makeReady () {
        this.$store.commit('READY')
      }
    },
    mounted () {
      if (window.location.pathname !== '/') {
        this.makeReady()
      }
    },
    components: { AppHeader }
  }
</script>

<style>
  @import 'style/imports';
  @import 'style/global';
</style>



// WEBPACK FOOTER //
// src/App.vue